import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';
import { IconButton, IconButtonProps } from '../IconButton';
import { TagOption } from './utils/Tags.types';

export type TagOptionActionProps = BpDesignSystem.Props<{
  onClick: (option?: TagOption) => void;
  option?: TagOption;
  iconName: IconButtonProps['iconName'];
  key: string;
}>;

export const TagOptionAction: FC<TagOptionActionProps> = ({
  onClick,
  option,
  iconName,
  key,
  dataTest,
  style,
  className,
  sx
}) => (
  <IconButton
    key={key}
    dataTest={dataTest}
    style={{ pointerEvents: 'all', ...style }}
    className={className}
    sx={sx}
    iconName={iconName}
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(option);
    }}
    size="small"
  />
);

export const EditTagOptionAction: FC<Omit<TagOptionActionProps, 'iconName'>> = ({
  onClick,
  option,
  key,
  dataTest,
  style,
  className,
  sx
}) => (
  <TagOptionAction
    iconName="edit"
    onClick={onClick}
    option={option}
    key={key}
    dataTest={dataTest}
    style={style}
    sx={sx}
    className={className}
  />
);

export const DeleteTagOptionAction: FC<Omit<TagOptionActionProps, 'iconName'>> = ({
  onClick,
  option,
  key,
  dataTest,
  style,
  className,
  sx
}) => (
  <TagOptionAction
    iconName="delete"
    onClick={onClick}
    option={option}
    key={key}
    dataTest={dataTest}
    style={style}
    sx={sx}
    className={className}
  />
);
